import React from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { t } from 'ttag';

import Form from '../../../components/Form';
import FormField from '../../../components/FormField';
import Loading from '../../../components/Loading';
import useApi from '../../../api';
import useCreateForm from '../../../hooks/useCreateForm';
import useEditForm from '../../../hooks/useEditForm';
import useUser from '../../../auth/hooks';

const BaseForm = ({ initial, edit, onSubmit, errors }) => {
  const { user } = useUser();
  const api = useApi();
  return (
    <Form onSubmit={onSubmit} initial={initial} errors={errors}>
      {({ data, change, errors, submit }) => (
        <div>
          {user.isAdmin && (
            <FormField
              required
              fullWidth
              query={api.schema.clubs.many()[0]}
              preInit={edit}
              dataKey='clubs'
              variables={{}}
              type='remoteSelect'
              margin='normal'
              label={t`Оберіть клуб`}
              id='clubId'
              name='clubId'
              variant='outlined'
              value={data.clubId}
              errors={errors.club_id}
              labelKey='fullName'
              onChange={change}
            />
          )}
          <FormField
            required
            fullWidth
            type='text'
            margin='normal'
            label={t`Назва залу`}
            id='name'
            name='name'
            autoComplete='name'
            variant='outlined'
            value={data.name}
            errors={errors.name}
            onChange={change}
          />
          <FormField
            required
            fullWidth
            type='text'
            margin='normal'
            label={t`Місто`}
            id='city'
            name='city'
            autoComplete='city'
            variant='outlined'
            value={data.city}
            errors={errors.city}
            onChange={change}
          />
          <FormField
            required
            fullWidth
            type='text'
            margin='normal'
            label={t`Адреса`}
            id='address'
            name='address'
            autoComplete='address'
            variant='outlined'
            value={data.address}
            errors={errors.address}
            onChange={change}
          />
          <FormField
            required
            fullWidth
            type='text'
            margin='normal'
            label={t`Телефон`}
            id='phone'
            name='phone'
            variant='outlined'
            value={data.phone}
            errors={errors.phone}
            onChange={change}
          />
          <FormField
            required
            fullWidth
            type='text'
            margin='normal'
            label={t`Email`}
            id='email'
            name='email'
            variant='outlined'
            value={data.email}
            errors={errors.email}
            onChange={change}
          />
          <FormField
            required
            fullWidth
            type='text'
            margin='normal'
            label={t`Адміністратор`}
            id='administrator'
            name='administrator'
            variant='outlined'
            value={data.administrator}
            errors={errors.administrator}
            onChange={change}
          />
          <Button
            style={{ margin: '20px 0 20px 0' }}
            margin='normal'
            type='button'
            fullWidth
            variant='contained'
            color='primary'
            onClick={submit}
          >
            {t`Зберегти`}
          </Button>
        </div>
      )}
    </Form>
  );
};

const getInitialData = (row) => ({
  clubId: row.clubId || null,
  name: row.name || '',
  city: row.city || '',
  address: row.address || '',
  phone: row.phone || '',
  email: row.email || '',
  administrator: row.administrator || '',
});

export const EditForm = () => {
  const api = useApi();
  const { loading, data, onSubmit, errors } = useEditForm({
    schema: api.schema.gyms,
    router: api.router.gyms,
  });

  if (loading) return <Loading />;

  return (
    <>
      <h2>{t`Редагувати зал: ${data.name}`}</h2>
      <Paper>
        <Box m={4}>
          <BaseForm
            initial={getInitialData(data)}
            onSubmit={onSubmit}
            errors={errors}
            edit
          />
        </Box>
      </Paper>
    </>
  );
};

export const CreateForm = () => {
  const api = useApi();
  const { loading, onSubmit, errors } = useCreateForm({
    schema: api.schema.gyms,
    router: api.router.gyms,
  });

  if (loading) return <Loading />;

  return (
    <>
      <h2>{t`Додати зал`}</h2>
      <Paper>
        <Box m={4}>
          <BaseForm
            initial={getInitialData({})}
            onSubmit={onSubmit}
            errors={errors}
            edit={false}
          />
        </Box>
      </Paper>
    </>
  );
};
